import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import NotificationList from "./tabItems/NotificationList";
import AddNotification from "./tabItems/AddNotification";
import { setNotification } from "../../store/slices/notificationSlice";

export const notificationTabConfig = {
    LIST: "1",
    ADD: "2"
}

const NotifcationsTab = () => {
    const [currentTab, setCurrentTab] = useState(notificationTabConfig.LIST);
    const [tabTada, setTabData] = useState({});
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setNotification({}));
    }, [])

    const onSwitchTab = (key, data) => {
        setCurrentTab(key);
    }

    const tabs = [
        {
            key: notificationTabConfig.LIST,
            label: 'Notifications',
            children: <NotificationList onSwitchTab={onSwitchTab} />,
        },
        {
            key: notificationTabConfig.ADD,
            label: 'Add / Modify Notification',
            children: <AddNotification onSwitchTab={onSwitchTab} tabProps={{}} />,
        }
    ];

    const onChange = (key) => {
        setCurrentTab(key);
        if (key !== notificationTabConfig.ADD) {
            dispatch(setNotification({}));
        }
    };

    return (
        <div>
            
            <div className="text-2xl pb-3">Notifications</div>
            <div className="px-4 border pb-6 bg-white pop-left">
                <Tabs defaultActiveKey="1" activeKey={currentTab} items={tabs} onChange={onChange} />
            </div>
        </div>
    )
}

export default NotifcationsTab;